/** Display targeting group labels — Display Media only since NPJB-613 flattened PGN's lanes. */
export const ABM_GROUP_LABEL = 'Account Based (ABM) Products';
export const CBM_GROUP_LABEL = 'Contact Based (CBM) Products';

/** Short lane prefix for a recap item (`ABM: Custom Interactive Banners`). */
export const TARGETING_TYPE_SHORT_LABEL: Record<string, string> = {
  abm: 'ABM',
  cbm: 'CBM',
};
